///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { ActivityDTO } from '../../../../../services/project-socket/activity-dto.model';

export class GtthUpdateMainConfigCommand extends GtthAbstractCommand {
    getCommandName(): string {
        return 'GtthUpdateMainConfigCommand';
    }

    doCommand(): void {
        const mainConfig = this.historyService.logicalTopology.toGeoJsonMainConfig(this.historyService, this.project.name);
        const activity = this.createActivityDTO(false);
        activity.logicalTopology = mainConfig;
        this.sendActivity(activity);
    }

    doCommandActivity(activityDto: ActivityDTO): void {
        if (activityDto.successful) {
            this.historyService.logicalTopology.parseGeoJsonMainConfig(activityDto.logicalTopology, this.historyService);
        }

        if (this.historyService.isEditModeEnabled && activityDto?.error?.message) {
            this.historyService.notificationService.showError(activityDto.error.message);
        }

        if (this.commandResolve) {
            this.commandResolve(activityDto.successful);
        }
    }
}
